import React, { useState, useEffect } from 'react';
import { Pie, Bar } from 'react-chartjs-2';
import { filterCandidate } from '../hunting/services';
import { getCvs } from '../cv/services';

import { Grid, Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const InsightsDashboard = () => {
  const [searchCriteria, setSearchCriteria] = useState({
    // ... (unchanged)
  });

  const [candidates, setCandidates] = useState(null);
  const [cvs, setCvs] = useState(null);
  const [searchResults, setSearchResults] = useState(null);

  const handleSearch = async () => {
    try {
      const response = await filterCandidate(searchCriteria);

      if (response.status === 200) {
        const data = response.data;
        setSearchResults(data);
        setCandidates(data);
      } else {
        console.error('Error in search:', response.statusText);
      }

     
    } catch (error) {
      console.error('Error in search:', error.message);
    }
  };

  useEffect(() => {
    handleSearch();
  }, []); // Assuming you want to perform the search once when the component mounts

  const ages = candidates ? candidates.map(candidate => candidate.age) : [];

  const genderCounts = candidates
    ? candidates.reduce((counts, candidate) => {
        const { gender } = candidate;
        if (gender === 'male' || gender === 'female' || gender === '') {
          counts[gender] = (counts[gender] || 0) + 1;
        }
        return counts;
      }, {})
    : {};

  const civilStatusCounts = candidates
    ? candidates.reduce((counts, candidate) => {
        counts[candidate.civilStatus] = (counts[candidate.civilStatus] || 0) + 1;
        return counts;
      }, {})
    : {};

  const availabilityCounts = candidates
    ? candidates.reduce((counts, candidate) => {
        counts[candidate.availability] = (counts[candidate.availability] || 0) + 1;
        return counts;
      }, {})
    : {};

  const appliedPositionCounts = candidates
    ? candidates.reduce((counts, candidate) => {
        counts[candidate?.personalInfo?.appliedPosition] =
          (counts[candidate?.personalInfo?.appliedPosition] || 0) + 1;
        return counts;
      }, {})
    : {};

  const ageData = {
    labels: ['18-24', '25-34', '35-44', '45+'],
    datasets: [
      {
        data: [
          ages.filter(age => age >= 18 && age <= 24).length,
          ages.filter(age => age >= 25 && age <= 34).length,
          ages.filter(age => age >= 35 && age <= 44).length,
          ages.filter(age => age >= 45).length,
        ],
        backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0'],
      },
    ],
  };

  const genderData = {
    labels: Object.keys(genderCounts),
    datasets: [
      {
        data: Object.values(genderCounts),
        backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
      },
    ],
  };

  const civilStatusData = {
    labels: Object.keys(civilStatusCounts),
    datasets: [
      {
        data: Object.values(civilStatusCounts),
        backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
      },
    ],
  };

  const availabilityData = {
    labels: Object.keys(availabilityCounts),
    datasets: [
      {
        label: 'Count',
        data: Object.values(availabilityCounts),
        backgroundColor: '#FF6384',
      },
    ],
  };

  const appliedPositionData = {
    labels: Object.keys(appliedPositionCounts),
    datasets: [
      {
        label: 'Count',
        data: Object.values(appliedPositionCounts),
        backgroundColor: '#FF6384',
      },
    ],
  };

  const appliedPositionRows = Object.entries(appliedPositionCounts).map(([position, count]) => ({ position, count }));

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <Card style={{ background: 'rgba(255, 255, 255, 0.4)', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)' }}>
            <div style={{ textAlign: 'center' }}>
              <div>
                <h3>Age Range</h3>
                {ages.length > 0 && <Pie data={ageData} />}
              </div>
            </div>
          </Card>
        </Grid>
        <Grid item xs={4}>
          <Card style={{ background: 'rgba(255, 255, 255, 0.4)', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)' }}>
            <div style={{ textAlign: 'center' }}>
              <div>
                <h3>Gender</h3>
                {Object.keys(genderCounts).length > 0 && <Pie data={genderData} />}
              </div>
            </div>
          </Card>
        </Grid>
        <Grid item xs={4}>
          <Card style={{ background: 'rgba(255, 255, 255, 0.4)', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)' }}>
            <div style={{ textAlign: 'center' }}>
              <div>
                <h3>Civil Status</h3>
                {Object.keys(civilStatusCounts).length > 0 && <Pie data={civilStatusData} />}
              </div>
            </div>
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Card style={{ background: 'rgba(255, 255, 255, 0.4)', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)' }}>
            <div style={{ textAlign: 'center' }}>
              <div>
                <h3>Availability</h3>
                {Object.keys(availabilityCounts).length > 0 && <Bar data={availabilityData} />}
              </div>
            </div>
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Card style={{ background: 'rgba(255, 255, 255, 0.4)', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)' }}>
            <div style={{ textAlign: 'center' }}>
              <div>
                <h3>Applied Positions</h3>
                {Object.keys(appliedPositionCounts).length > 0 && <Bar data={appliedPositionData} />}
              </div>
            </div>
          </Card>
        </Grid>

      </Grid>
    </div>
  );
};

export default InsightsDashboard;
